import { Header } from '@/components/organisms/header'
import { SideMenu } from '@/components/organisms/side-menu'
import { mainColumnStyle, mainContainerStyle, wholeContainerStyle } from '@/constants/layout'
import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Assignment } from '@/components/organisms/space-manager/assignment'
import { SpaceAsset, isSpaceAsset } from '@/models/guest-app/asset'
import { getAssetList } from '@/apis/aipass'
import { LoadingFull } from '@/components/molecules/loading-full'
import { isEmpty } from 'lodash'
import { AccountContext } from '@/contexts/account'
import { hasSpaceVisibility } from '@/libs/plugins'

export const SpaceManager: React.FC = () => {
  const [spaceAssets, setSpaceAssets] = useState<SpaceAsset[]>([])
  const [loading, setLoading] = useState(false)

  const { t } = useTranslation()
  const history = useHistory()
  const { plugins } = useContext<any>(AccountContext)

  const shouldShowSpace = useMemo(() => hasSpaceVisibility(plugins), [plugins])
  const isPluginsLoaded = Array.isArray(plugins)

  const fetchSpaceAsset = useCallback(async () => {
    setLoading(true)
    const result = await getAssetList()
    setSpaceAssets(result.filter(asset => isSpaceAsset(asset)) as SpaceAsset[])
    setLoading(false)
  }, [])

  useEffect(() => {
    if (!isPluginsLoaded) {
      return
    }
    if (!shouldShowSpace) {
      history.push('/dashboard')
      return
    }
    fetchSpaceAsset()
  }, [isPluginsLoaded, shouldShowSpace, history, fetchSpaceAsset])

  return (
    <div css={wholeContainerStyle}>
      <SideMenu />
      <div css={mainColumnStyle}>
        <Header title={t('Space-Management')} />
        <div css={mainContainerStyle}>{!isEmpty(spaceAssets) && <Assignment spaceAssets={spaceAssets} />}</div>
      </div>
      <LoadingFull isLoading={!isPluginsLoaded || loading} />
    </div>
  )
}
